export * from './onboarding-contrato.component';
